var map = {
	"./l/AD.svg": "a701",
	"./l/AE.svg": "9deb",
	"./l/AF.svg": "a726",
	"./l/AFRUN.svg": "ac1e",
	"./l/AG.svg": "6c57",
	"./l/AI.svg": "35cc",
	"./l/AL.svg": "3d06",
	"./l/AM.svg": "ac5c",
	"./l/AMS.svg": "9d9f",
	"./l/AO.svg": "93af",
	"./l/AQ.svg": "d9d7",
	"./l/AR.svg": "3104",
	"./l/AS.svg": "3c1e",
	"./l/AT.svg": "dd6c",
	"./l/AU.svg": "5519",
	"./l/AW.svg": "2282",
	"./l/AX.svg": "5a2f",
	"./l/AZ.svg": "fc08",
	"./l/BA.svg": "cda3",
	"./l/BB.svg": "25ed",
	"./l/BD.svg": "2ac8",
	"./l/BE.svg": "6ebc",
	"./l/BF.svg": "2cc0",
	"./l/BG.svg": "f4a0",
	"./l/BH.svg": "d101",
	"./l/BI.svg": "bbc6",
	"./l/BJ.svg": "dc3c",
	"./l/BL.svg": "b911",
	"./l/BM.svg": "a430",
	"./l/BN.svg": "8078",
	"./l/BO.svg": "c870",
	"./l/BQ-BO.svg": "2b14",
	"./l/BQ-SA.svg": "7049",
	"./l/BQ-SE.svg": "923e",
	"./l/BR.svg": "e090",
	"./l/BS.svg": "e872",
	"./l/BT.svg": "69e8",
	"./l/BV.svg": "26cd",
	"./l/BW.svg": "92a2",
	"./l/BY.svg": "2aa2",
	"./l/BZ.svg": "1abe",
	"./l/CA.svg": "9585",
	"./l/CC.svg": "4936",
	"./l/CD.svg": "73d3",
	"./l/CF.svg": "1956",
	"./l/CG.svg": "bedc",
	"./l/CH.svg": "4b4a",
	"./l/CI.svg": "873d",
	"./l/CK.svg": "044b",
	"./l/CL.svg": "c3e1",
	"./l/CM.svg": "2ff6",
	"./l/CN.svg": "174f",
	"./l/CO.svg": "809f",
	"./l/CR.svg": "0e35",
	"./l/CU.svg": "60aa",
	"./l/CV.svg": "5826",
	"./l/CW.svg": "fa05",
	"./l/CX.svg": "0efc",
	"./l/CY.svg": "a70a",
	"./l/CZ.svg": "da0a",
	"./l/DE.svg": "369e",
	"./l/DJ.svg": "cbda",
	"./l/DK.svg": "2d14",
	"./l/DM.svg": "5155",
	"./l/DO.svg": "62f4",
	"./l/DZ.svg": "42c5",
	"./l/EC.svg": "c47d",
	"./l/EE.svg": "ce20",
	"./l/EG.svg": "67dd",
	"./l/EH.svg": "d1b3",
	"./l/ER.svg": "0c82",
	"./l/ES.svg": "a5e4",
	"./l/ET.svg": "d406",
	"./l/EU.svg": "3cd8",
	"./l/FI.svg": "7033",
	"./l/FJ.svg": "87eb",
	"./l/FK.svg": "40f3",
	"./l/FM.svg": "c5e1",
	"./l/FO.svg": "4d54",
	"./l/FR.svg": "7800",
	"./l/GA.svg": "38ae",
	"./l/GB-ENG.svg": "bfb6",
	"./l/GB-NIR.svg": "8666",
	"./l/GB-SCT.svg": "f66e",
	"./l/GB-UKM.svg": "5ea3",
	"./l/GB-WLS.svg": "23da",
	"./l/GB.svg": "24ab",
	"./l/GD.svg": "819e",
	"./l/GE.svg": "3338",
	"./l/GF.svg": "938a",
	"./l/GG.svg": "6278",
	"./l/GH.svg": "66f9",
	"./l/GI.svg": "64f2",
	"./l/GL.svg": "3995",
	"./l/GM.svg": "5f0a",
	"./l/GN.svg": "3c70",
	"./l/GP.svg": "4b45",
	"./l/GQ.svg": "2348",
	"./l/GR.svg": "33a3",
	"./l/GS.svg": "b7b5",
	"./l/GT.svg": "c351",
	"./l/GU.svg": "4052",
	"./l/GW.svg": "d3cd",
	"./l/GY.svg": "d554",
	"./l/HK.svg": "cdc8",
	"./l/HM.svg": "e5ab",
	"./l/HN.svg": "8660",
	"./l/HR.svg": "df3f",
	"./l/HT.svg": "fc8a",
	"./l/HU.svg": "2516",
	"./l/ID.svg": "fa48",
	"./l/IE.svg": "2eac",
	"./l/IL.svg": "6bfb",
	"./l/IM.svg": "a02c",
	"./l/IN.svg": "5cec",
	"./l/IO.svg": "ad24",
	"./l/IQ.svg": "f753",
	"./l/IR.svg": "55ea",
	"./l/IS.svg": "18b3",
	"./l/IT.svg": "52b8",
	"./l/JE.svg": "cbf7",
	"./l/JM.svg": "7a772",
	"./l/JO.svg": "7075",
	"./l/JP.svg": "072a",
	"./l/KE.svg": "ddd8",
	"./l/KG.svg": "5e57",
	"./l/KH.svg": "9fb7",
	"./l/KI.svg": "d237",
	"./l/KM.svg": "315f",
	"./l/KN-SK.svg": "d50a",
	"./l/KP.svg": "f24d",
	"./l/KR.svg": "f10c",
	"./l/KW.svg": "138c",
	"./l/KY.svg": "461e",
	"./l/KZ.svg": "1bdf",
	"./l/LA.svg": "539d",
	"./l/LB.svg": "fde0",
	"./l/LC.svg": "7efa",
	"./l/LI.svg": "9075",
	"./l/LK.svg": "93ed",
	"./l/LR.svg": "79d9",
	"./l/LS.svg": "56cf",
	"./l/LT.svg": "a0de",
	"./l/LU.svg": "5227",
	"./l/LV.svg": "83fe",
	"./l/LY.svg": "142a",
	"./l/MA.svg": "57a0",
	"./l/MC.svg": "f0c4",
	"./l/MD.svg": "6103",
	"./l/ME.svg": "05a5",
	"./l/MF.svg": "11b2",
	"./l/MG.svg": "819d",
	"./l/MH.svg": "cdf7",
	"./l/MK.svg": "a292",
	"./l/ML.svg": "a9bb",
	"./l/MM.svg": "2225",
	"./l/MN.svg": "e1e4",
	"./l/MO.svg": "5a91",
	"./l/MP.svg": "099d",
	"./l/MQ-UNF.svg": "efb5",
	"./l/MQ.svg": "9c1a",
	"./l/MR.svg": "aff5",
	"./l/MS.svg": "3580",
	"./l/MT.svg": "6656",
	"./l/MU.svg": "cd00",
	"./l/MV.svg": "2699",
	"./l/MW.svg": "5998",
	"./l/MX.svg": "42d4",
	"./l/MY.svg": "7f59",
	"./l/MZ.svg": "75a7",
	"./l/NA.svg": "78008",
	"./l/NC.svg": "e8ab",
	"./l/NE.svg": "a1de",
	"./l/NF.svg": "0c0a",
	"./l/NG.svg": "04f2",
	"./l/NI.svg": "848e",
	"./l/NL.svg": "68dd",
	"./l/NO.svg": "f9d2",
	"./l/NP.svg": "e46d",
	"./l/NR.svg": "1367",
	"./l/NU.svg": "6ad5",
	"./l/NZ.svg": "b997",
	"./l/OM.svg": "f45a",
	"./l/PA.svg": "bf3b",
	"./l/PE.svg": "af9f",
	"./l/PF.svg": "c300",
	"./l/PG.svg": "1a6e",
	"./l/PH.svg": "4856",
	"./l/PK.svg": "3dc4",
	"./l/PL.svg": "8194",
	"./l/PM-UNF.svg": "7603",
	"./l/PM.svg": "9407",
	"./l/PN.svg": "12d1",
	"./l/PR.svg": "215c",
	"./l/PS.svg": "e8e1",
	"./l/PT.svg": "2ff3",
	"./l/PW.svg": "c7d2",
	"./l/PY.svg": "3a5d",
	"./l/QA.svg": "1ed5",
	"./l/RAINBOW.svg": "69c9",
	"./l/RE.svg": "7e11",
	"./l/RO.svg": "dccf",
	"./l/RS.svg": "dfeb",
	"./l/RU.svg": "e0c2",
	"./l/RW.svg": "90bc",
	"./l/SA.svg": "2287",
	"./l/SB.svg": "b75e",
	"./l/SC.svg": "7ad2",
	"./l/SD.svg": "4ec8",
	"./l/SE.svg": "1a5f",
	"./l/SG.svg": "3703",
	"./l/SH.svg": "c773",
	"./l/SI.svg": "a07c",
	"./l/SJ.svg": "4bd7",
	"./l/SK.svg": "12aa",
	"./l/SL.svg": "0a3c",
	"./l/SM.svg": "3726",
	"./l/SN.svg": "4365",
	"./l/SO.svg": "b182",
	"./l/SR.svg": "d915",
	"./l/SS.svg": "ef1b",
	"./l/ST.svg": "c825",
	"./l/SV.svg": "34d0",
	"./l/SX.svg": "15be",
	"./l/SY.svg": "8752",
	"./l/SZ.svg": "361b",
	"./l/TC.svg": "8c61",
	"./l/TD.svg": "bdb5",
	"./l/TF.svg": "592e",
	"./l/TG.svg": "3fe6",
	"./l/TH.svg": "07ef",
	"./l/TJ.svg": "9c0f",
	"./l/TK.svg": "288b",
	"./l/TL.svg": "fe48",
	"./l/TM.svg": "20b7",
	"./l/TN.svg": "a14a",
	"./l/TO.svg": "223e",
	"./l/TR.svg": "4ee9",
	"./l/TT.svg": "cba9",
	"./l/TV.svg": "95d5",
	"./l/TW.svg": "e771",
	"./l/TZ.svg": "6336",
	"./l/UA.svg": "e014",
	"./l/UG.svg": "1b89",
	"./l/UM.svg": "4e2c",
	"./l/UNASUR.svg": "7d8d",
	"./l/US.svg": "d541",
	"./l/UY.svg": "e95d",
	"./l/UZ.svg": "b501",
	"./l/VA.svg": "c5cd",
	"./l/VC.svg": "7ba3",
	"./l/VE.svg": "6193",
	"./l/VG.svg": "ade4",
	"./l/VI.svg": "28dc",
	"./l/VN.svg": "4e1e",
	"./l/VU.svg": "31a5",
	"./l/WF.svg": "32f2",
	"./l/WS.svg": "6335",
	"./l/XK.svg": "bcaa",
	"./l/YE.svg": "5ef9",
	"./l/ZA.svg": "9e89",
	"./l/ZM.svg": "2462",
	"./l/ZW.svg": "50a6",
	"./m/AD.svg": "ff5a",
	"./m/AE.svg": "edbb",
	"./m/AF.svg": "154e",
	"./m/AFRUN.svg": "cabb",
	"./m/AG.svg": "0d5c",
	"./m/AI.svg": "8737",
	"./m/AL.svg": "be9e",
	"./m/AM.svg": "6b7e",
	"./m/AMS.svg": "30ba",
	"./m/AO.svg": "71a8",
	"./m/AQ.svg": "f300",
	"./m/AR.svg": "3123",
	"./m/AS.svg": "d5d7",
	"./m/AT.svg": "4218",
	"./m/AU.svg": "d17b",
	"./m/AW.svg": "623f",
	"./m/AX.svg": "99d9",
	"./m/AZ.svg": "8385",
	"./m/BA.svg": "9e0f",
	"./m/BB.svg": "b5eb",
	"./m/BD.svg": "3d7c",
	"./m/BE.svg": "76b8",
	"./m/BF.svg": "7cf9",
	"./m/BG.svg": "5788",
	"./m/BH.svg": "39b0",
	"./m/BI.svg": "0ace",
	"./m/BJ.svg": "0f36",
	"./m/BL.svg": "9053",
	"./m/BM.svg": "0216",
	"./m/BN.svg": "0e1a",
	"./m/BO.svg": "7ec3",
	"./m/BQ-BO.svg": "638e",
	"./m/BQ-SA.svg": "bb19",
	"./m/BQ-SE.svg": "11d4c",
	"./m/BR.svg": "9a28",
	"./m/BS.svg": "b1d4",
	"./m/BT.svg": "f642",
	"./m/BV.svg": "bcf9",
	"./m/BW.svg": "8fe2",
	"./m/BY.svg": "e696",
	"./m/BZ.svg": "8fef",
	"./m/CA.svg": "f15f",
	"./m/CC.svg": "84a2",
	"./m/CD.svg": "9d4d",
	"./m/CF.svg": "82cb",
	"./m/CG.svg": "506f",
	"./m/CH.svg": "1895",
	"./m/CI.svg": "5a77",
	"./m/CK.svg": "ec00",
	"./m/CL.svg": "bea6",
	"./m/CM.svg": "c256",
	"./m/CN.svg": "ef0e",
	"./m/CO.svg": "c545",
	"./m/CR.svg": "53cd",
	"./m/CU.svg": "d2ee",
	"./m/CV.svg": "90a0",
	"./m/CW.svg": "ebc2",
	"./m/CX.svg": "f7bd",
	"./m/CY.svg": "a2d6",
	"./m/CZ.svg": "ff7e",
	"./m/DE.svg": "ddc6",
	"./m/DJ.svg": "5aff",
	"./m/DK.svg": "0e74",
	"./m/DM.svg": "177a",
	"./m/DO.svg": "36b0",
	"./m/DZ.svg": "9b70",
	"./m/EC.svg": "85d0",
	"./m/EE.svg": "64e0",
	"./m/EG.svg": "18d7",
	"./m/EH.svg": "b980",
	"./m/ER.svg": "8259",
	"./m/ES.svg": "f799",
	"./m/ET.svg": "2f32",
	"./m/EU.svg": "72f2",
	"./m/FI.svg": "fb53",
	"./m/FJ.svg": "93e2",
	"./m/FK.svg": "ce44",
	"./m/FM.svg": "a587",
	"./m/FO.svg": "70fd",
	"./m/FR.svg": "7541",
	"./m/GA.svg": "16bd",
	"./m/GB-ENG.svg": "1dcc",
	"./m/GB-NIR.svg": "7a30",
	"./m/GB-SCT.svg": "c561",
	"./m/GB-UKM.svg": "548b",
	"./m/GB-WLS.svg": "4829",
	"./m/GD.svg": "7767",
	"./m/GE.svg": "dd38",
	"./m/GF.svg": "e631",
	"./m/GG.svg": "afd6",
	"./m/GH.svg": "d701",
	"./m/GI.svg": "f4c5",
	"./m/GL.svg": "c8cb",
	"./m/GM.svg": "a150",
	"./m/GN.svg": "f7ff",
	"./m/GP.svg": "9818",
	"./m/GQ.svg": "67bb",
	"./m/GR.svg": "8dc2",
	"./m/GS.svg": "4681",
	"./m/GT.svg": "d0bd",
	"./m/GU.svg": "ad07",
	"./m/GW.svg": "ae6c",
	"./m/GY.svg": "50f2",
	"./m/HK.svg": "7b1d",
	"./m/HM.svg": "61e4",
	"./m/HN.svg": "8891",
	"./m/HR.svg": "f0f1",
	"./m/HT.svg": "46c5",
	"./m/HU.svg": "d7cc",
	"./m/ID.svg": "5c0b",
	"./m/IE.svg": "01ad",
	"./m/IL.svg": "8b16",
	"./m/IM.svg": "486f",
	"./m/IN.svg": "c01ef",
	"./m/IO.svg": "1cd4",
	"./m/IQ.svg": "87bf",
	"./m/IR.svg": "f6d4",
	"./m/IS.svg": "e654",
	"./m/IT.svg": "65ca",
	"./m/JE.svg": "d740",
	"./m/JM.svg": "eb96",
	"./m/JO.svg": "07f7",
	"./m/JP.svg": "d164",
	"./m/KE.svg": "5469",
	"./m/KG.svg": "63ec",
	"./m/KH.svg": "7137",
	"./m/KI.svg": "6b56",
	"./m/KM.svg": "cae6",
	"./m/KN-SK.svg": "5930",
	"./m/KP.svg": "31237",
	"./m/KR.svg": "0323",
	"./m/KW.svg": "6a45",
	"./m/KY.svg": "f2ec",
	"./m/KZ.svg": "e394",
	"./m/LA.svg": "c14f",
	"./m/LB.svg": "96a4",
	"./m/LC.svg": "692e",
	"./m/LI.svg": "31177",
	"./m/LK.svg": "2ca7",
	"./m/LR.svg": "44c7",
	"./m/LS.svg": "3030",
	"./m/LT.svg": "d212",
	"./m/LU.svg": "abbc",
	"./m/LV.svg": "3667",
	"./m/LY.svg": "4c70",
	"./m/MA.svg": "ce58",
	"./m/MC.svg": "80be",
	"./m/MD.svg": "dd43",
	"./m/ME.svg": "b023",
	"./m/MF.svg": "1764",
	"./m/MG.svg": "5ace",
	"./m/MH.svg": "f892",
	"./m/MK.svg": "d350",
	"./m/ML.svg": "097a",
	"./m/MM.svg": "59b5",
	"./m/MN.svg": "0d60",
	"./m/MO.svg": "1873",
	"./m/MP.svg": "b665",
	"./m/MQ-UNF.svg": "92f9",
	"./m/MQ.svg": "19e4",
	"./m/MR.svg": "14cc",
	"./m/MS.svg": "4a56",
	"./m/MT.svg": "4c3b",
	"./m/MU.svg": "f7c3",
	"./m/MV.svg": "4675",
	"./m/MW.svg": "e7c8",
	"./m/MX.svg": "6a27",
	"./m/MY.svg": "21b8",
	"./m/MZ.svg": "7d90",
	"./m/NA.svg": "2572",
	"./m/NC.svg": "561e",
	"./m/NE.svg": "8c77",
	"./m/NF.svg": "d53a",
	"./m/NG.svg": "d54c",
	"./m/NI.svg": "c9f1",
	"./m/NL.svg": "d761",
	"./m/NO.svg": "482e",
	"./m/NP.svg": "23af",
	"./m/NR.svg": "0dd3",
	"./m/NU.svg": "0e9f",
	"./m/NZ.svg": "7c0e",
	"./m/OM.svg": "623c",
	"./m/PA.svg": "682a",
	"./m/PE.svg": "2835",
	"./m/PF.svg": "a94d",
	"./m/PG.svg": "35f8",
	"./m/PH.svg": "dba7",
	"./m/PK.svg": "5b09",
	"./m/PL.svg": "0253",
	"./m/PM-UNF.svg": "ca72",
	"./m/PM.svg": "7377",
	"./m/PN.svg": "2710",
	"./m/PR.svg": "7a6b",
	"./m/PS.svg": "42c4",
	"./m/PT.svg": "c4dd",
	"./m/PW.svg": "93e2a",
	"./m/PY.svg": "bddf",
	"./m/QA.svg": "9a37",
	"./m/RAINBOW.svg": "9aa3",
	"./m/RE.svg": "8a39",
	"./m/RO.svg": "1b91",
	"./m/RS.svg": "5a64",
	"./m/RU.svg": "4fc9",
	"./m/RW.svg": "b5c7",
	"./m/SA.svg": "8a3d",
	"./m/SB.svg": "1f27",
	"./m/SC.svg": "ab1b",
	"./m/SD.svg": "37cc",
	"./m/SE.svg": "b16b",
	"./m/SG.svg": "e2ce",
	"./m/SH.svg": "4c68",
	"./m/SI.svg": "08c1",
	"./m/SJ.svg": "ab0a",
	"./m/SK.svg": "2869",
	"./m/SL.svg": "8562",
	"./m/SM.svg": "6da8",
	"./m/SN.svg": "744b",
	"./m/SO.svg": "26b6",
	"./m/SR.svg": "0812",
	"./m/SS.svg": "d8e2",
	"./m/ST.svg": "dcb8",
	"./m/SV.svg": "ab26",
	"./m/SX.svg": "1cc2",
	"./m/SY.svg": "cdf6",
	"./m/SZ.svg": "5a51",
	"./m/TC.svg": "677a",
	"./m/TD.svg": "cf1d",
	"./m/TF.svg": "b225",
	"./m/TG.svg": "9c7a",
	"./m/TH.svg": "02ee",
	"./m/TJ.svg": "65d6",
	"./m/TK.svg": "b833",
	"./m/TL.svg": "527f",
	"./m/TM.svg": "89b3",
	"./m/TN.svg": "eff2",
	"./m/TO.svg": "d6ed",
	"./m/TR.svg": "8bf8",
	"./m/TT.svg": "bedb",
	"./m/TV.svg": "a33e",
	"./m/TW.svg": "cceb",
	"./m/TZ.svg": "1b8a",
	"./m/UA.svg": "fe40",
	"./m/UG.svg": "716c",
	"./m/UM.svg": "dc2e",
	"./m/UNASUR.svg": "4946",
	"./m/US.svg": "3391",
	"./m/UY.svg": "6246",
	"./m/UZ.svg": "d660",
	"./m/VA.svg": "939a",
	"./m/VC.svg": "7ed6",
	"./m/VE.svg": "5861",
	"./m/VG.svg": "7b41",
	"./m/VI.svg": "9fd1",
	"./m/VN.svg": "b842",
	"./m/VU.svg": "06b6",
	"./m/WF.svg": "c61b",
	"./m/WS.svg": "37d0",
	"./m/XK.svg": "6b09",
	"./m/YE.svg": "b236",
	"./m/YT-UNF.svg": "93e5",
	"./m/ZA.svg": "a5f9",
	"./m/ZM.svg": "658f",
	"./m/ZW.svg": "18b6",
	"./s/AD.svg": "d843",
	"./s/AE.svg": "474a",
	"./s/AF.svg": "a1bd",
	"./s/AFRUN.svg": "639d",
	"./s/AG.svg": "baae",
	"./s/AI.svg": "f77a",
	"./s/AL.svg": "4f66",
	"./s/AM.svg": "a71d",
	"./s/AMS.svg": "2b36",
	"./s/AO.svg": "1bd7",
	"./s/AQ.svg": "de7f",
	"./s/AR.svg": "1dbc",
	"./s/AS.svg": "9076",
	"./s/AT.svg": "68e2",
	"./s/AU.svg": "0880",
	"./s/AW.svg": "9b86",
	"./s/AX.svg": "e216",
	"./s/AZ.svg": "f275",
	"./s/BA.svg": "3c0d",
	"./s/BB.svg": "1f23",
	"./s/BD.svg": "6f4d",
	"./s/BE.svg": "9698",
	"./s/BF.svg": "bf5a",
	"./s/BG.svg": "3e7c",
	"./s/BH.svg": "1525",
	"./s/BI.svg": "b186",
	"./s/BJ.svg": "504b",
	"./s/BL.svg": "fe26",
	"./s/BM.svg": "9774",
	"./s/BN.svg": "3cc9",
	"./s/BO.svg": "9a75",
	"./s/BQ-BO.svg": "16e9",
	"./s/BQ-SA.svg": "710b",
	"./s/BQ-SE.svg": "6482",
	"./s/BR.svg": "88f0",
	"./s/BS.svg": "7a70",
	"./s/BT.svg": "99e6",
	"./s/BV.svg": "4bb6",
	"./s/BW.svg": "dbc5",
	"./s/BY.svg": "bc59",
	"./s/BZ.svg": "e167",
	"./s/CA.svg": "05f1",
	"./s/CC.svg": "c527",
	"./s/CD.svg": "0fb0",
	"./s/CF.svg": "a67d",
	"./s/CG.svg": "9987",
	"./s/CH.svg": "85c4",
	"./s/CI.svg": "1e9b",
	"./s/CK.svg": "a891",
	"./s/CL.svg": "1209",
	"./s/CM.svg": "627e",
	"./s/CN.svg": "3f97",
	"./s/CO.svg": "1c90",
	"./s/CR.svg": "7c19",
	"./s/CU.svg": "25cd",
	"./s/CV.svg": "1375",
	"./s/CW.svg": "c520",
	"./s/CX.svg": "7625",
	"./s/CY.svg": "22fa",
	"./s/CZ.svg": "5c38",
	"./s/DE.svg": "58b9",
	"./s/DJ.svg": "9afa",
	"./s/DK.svg": "fb68",
	"./s/DM.svg": "4d40",
	"./s/DO.svg": "4aee",
	"./s/DZ.svg": "3a97",
	"./s/EC.svg": "123d",
	"./s/EE.svg": "23b6",
	"./s/EG.svg": "c002",
	"./s/EH.svg": "ccd6",
	"./s/ER.svg": "224c",
	"./s/ES.svg": "3ebb",
	"./s/ET.svg": "2556",
	"./s/EU.svg": "f768",
	"./s/FI.svg": "2284",
	"./s/FJ.svg": "8321",
	"./s/FK.svg": "9e97",
	"./s/FM.svg": "f3ad",
	"./s/FO.svg": "aa52",
	"./s/FR.svg": "ee55",
	"./s/GA.svg": "1a56",
	"./s/GB-ENG.svg": "975b",
	"./s/GB-NIR.svg": "b8f2",
	"./s/GB-SCT.svg": "6838",
	"./s/GB-UKM.svg": "8bd5",
	"./s/GB-WLS.svg": "dd7f",
	"./s/GD.svg": "3454",
	"./s/GE.svg": "6664",
	"./s/GF.svg": "7943",
	"./s/GG.svg": "90b5",
	"./s/GH.svg": "bd80",
	"./s/GI.svg": "7523",
	"./s/GL.svg": "6fd4",
	"./s/GM.svg": "c21c",
	"./s/GN.svg": "cbca",
	"./s/GP.svg": "82ac",
	"./s/GQ.svg": "07b19",
	"./s/GR.svg": "53a1",
	"./s/GS.svg": "b97e",
	"./s/GT.svg": "215f",
	"./s/GU.svg": "1d11",
	"./s/GW.svg": "8ee9",
	"./s/GY.svg": "e45e",
	"./s/HK.svg": "7b2f",
	"./s/HM.svg": "5fcc",
	"./s/HN.svg": "dfc8",
	"./s/HR.svg": "ca67",
	"./s/HT.svg": "d789",
	"./s/HU.svg": "e36b",
	"./s/ID.svg": "01f2",
	"./s/IE.svg": "868e",
	"./s/IL.svg": "5052",
	"./s/IM.svg": "a2a1",
	"./s/IN.svg": "a7c2",
	"./s/IO.svg": "ed86",
	"./s/IQ.svg": "c25f",
	"./s/IR.svg": "bad6",
	"./s/IS.svg": "8036",
	"./s/IT.svg": "7813",
	"./s/JE.svg": "842c",
	"./s/JM.svg": "a1cf",
	"./s/JO.svg": "0999",
	"./s/JP.svg": "0d1a",
	"./s/KE.svg": "92a4",
	"./s/KG.svg": "f000",
	"./s/KH.svg": "1ba0",
	"./s/KI.svg": "d49e",
	"./s/KM.svg": "9b2e",
	"./s/KN-SK.svg": "a713",
	"./s/KP.svg": "e7f4",
	"./s/KR.svg": "58e3",
	"./s/KW.svg": "51bc",
	"./s/KY.svg": "e6b3",
	"./s/KZ.svg": "91c1",
	"./s/LA.svg": "de38",
	"./s/LB.svg": "3b7e",
	"./s/LC.svg": "c4cf",
	"./s/LI.svg": "ea2c",
	"./s/LK.svg": "fbca",
	"./s/LR.svg": "3d08",
	"./s/LS.svg": "dc43",
	"./s/LT.svg": "589c",
	"./s/LU.svg": "8363",
	"./s/LV.svg": "9fdd",
	"./s/LY.svg": "1ad8",
	"./s/MA.svg": "8d94",
	"./s/MC.svg": "e457",
	"./s/MD.svg": "9d59",
	"./s/ME.svg": "6483",
	"./s/MF.svg": "2a83",
	"./s/MG.svg": "8cac",
	"./s/MH.svg": "99c0",
	"./s/MK.svg": "10f0",
	"./s/ML.svg": "8317",
	"./s/MM.svg": "a8d0",
	"./s/MN.svg": "2874",
	"./s/MO.svg": "2e4f",
	"./s/MP.svg": "5ab9",
	"./s/MQ-UNF.svg": "34bf",
	"./s/MQ.svg": "8975",
	"./s/MR.svg": "7f65e",
	"./s/MS.svg": "5147",
	"./s/MT.svg": "248d",
	"./s/MU.svg": "e6c3",
	"./s/MV.svg": "ec09",
	"./s/MW.svg": "fc65",
	"./s/MX.svg": "6689",
	"./s/MY.svg": "e690",
	"./s/MZ.svg": "b1af",
	"./s/NA.svg": "8199",
	"./s/NC.svg": "6a7d",
	"./s/NE.svg": "8bb6",
	"./s/NF.svg": "ad3f",
	"./s/NG.svg": "5101",
	"./s/NI.svg": "a16a",
	"./s/NL.svg": "f0ac",
	"./s/NO.svg": "ea01",
	"./s/NP.svg": "20cd",
	"./s/NR.svg": "5fb3",
	"./s/NU.svg": "5306",
	"./s/NZ.svg": "2fcb",
	"./s/OM.svg": "4322",
	"./s/PA.svg": "c077",
	"./s/PE.svg": "9e4d",
	"./s/PF.svg": "70b9",
	"./s/PG.svg": "4f06",
	"./s/PH.svg": "87ec",
	"./s/PK.svg": "83bb",
	"./s/PL.svg": "91e2",
	"./s/PM-UNF.svg": "2f4f",
	"./s/PM.svg": "0a5c",
	"./s/PN.svg": "8829",
	"./s/PR.svg": "37cb",
	"./s/PS.svg": "cb2b",
	"./s/PT.svg": "6769",
	"./s/PW.svg": "b7d2",
	"./s/PY.svg": "4ce7",
	"./s/QA.svg": "2cc2",
	"./s/RAINBOW.svg": "b895",
	"./s/RE.svg": "7933",
	"./s/RO.svg": "8a61",
	"./s/RS.svg": "e831",
	"./s/RU.svg": "3ad7",
	"./s/RW.svg": "98be",
	"./s/SA.svg": "c035",
	"./s/SB.svg": "8c2c",
	"./s/SC.svg": "1e4a",
	"./s/SD.svg": "c522",
	"./s/SE.svg": "8acd",
	"./s/SG.svg": "5eb5",
	"./s/SH.svg": "78f4",
	"./s/SI.svg": "c53e",
	"./s/SJ.svg": "dee8",
	"./s/SK.svg": "9321",
	"./s/SL.svg": "784b",
	"./s/SM.svg": "b151",
	"./s/SN.svg": "4831",
	"./s/SO.svg": "63fc",
	"./s/SR.svg": "3003",
	"./s/SS.svg": "b66a",
	"./s/ST.svg": "f939",
	"./s/SV.svg": "324e",
	"./s/SX.svg": "d3de",
	"./s/SY.svg": "ebad",
	"./s/SZ.svg": "d418",
	"./s/TC.svg": "0753",
	"./s/TD.svg": "24e2",
	"./s/TF.svg": "0e76",
	"./s/TG.svg": "3c81",
	"./s/TH.svg": "785d",
	"./s/TJ.svg": "fcc3",
	"./s/TK.svg": "47fd",
	"./s/TL.svg": "0e0d",
	"./s/TM.svg": "d100",
	"./s/TN.svg": "7e73",
	"./s/TO.svg": "bb79",
	"./s/TR.svg": "807c",
	"./s/TT.svg": "db69",
	"./s/TV.svg": "49a4",
	"./s/TW.svg": "5233",
	"./s/TZ.svg": "e9e4",
	"./s/UA.svg": "debb",
	"./s/UG.svg": "cf4f",
	"./s/UM.svg": "9bf1",
	"./s/UNASUR.svg": "6489",
	"./s/US.svg": "565e",
	"./s/UY.svg": "bc07",
	"./s/UZ.svg": "5af8",
	"./s/VA.svg": "18f9",
	"./s/VC.svg": "91d7",
	"./s/VE.svg": "157b",
	"./s/VG.svg": "d552",
	"./s/VI.svg": "522f",
	"./s/VN.svg": "ad13",
	"./s/VU.svg": "871a",
	"./s/WF.svg": "c66f",
	"./s/WS.svg": "a0d5",
	"./s/XK.svg": "51de",
	"./s/YE.svg": "6dc8",
	"./s/YT-UNF.svg": "36e9",
	"./s/ZA.svg": "538b",
	"./s/ZM.svg": "3fcf",
	"./s/ZW.svg": "60fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b68";